import LevelLadder from 'components/shared/levelLadder/LevelLadder';
import { useI18n } from 'hooks/useI18n';
import { UIOfferSkillsSection } from 'interfaces/ui/ui-offer-skills-section';
import { LANGUAGES_LEVELS } from 'model';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSection from '../JobOfferSection';
import JobOfferSubsection from '../JobOfferSubsection';
import SkillsItem from './SkillsItem';
import SkillsList from './SkillsList';
import SkillsNoStack from './SkillsNoStack';
import {
  StyledLanguage,
  StyledLanguageName,
  StyledLanguages,
  StyledSkillsLists,
  StyledSkillsSection
} from './SkillsSection.styled';
import SkillsSoftItem from './SkillsSoftItem';

const SkillsSection = (props: UIOfferSkillsSection) => {
  const { t } = useI18n('job-offer');
  const showTechsList =
    (props.skills && props.skills.must && props.skills.must?.length > 0) ||
    (props.skills.nice && props.skills.nice?.length > 0) ||
    (props.skills.extra && props.skills.extra?.length > 0);
  const showTechs = showTechsList || props.noStack;

  const showSoftSkills =
    (props.softSkills &&
      props.softSkills.must &&
      props.softSkills.must?.length > 0) ||
    (props.softSkills.nice && props.softSkills.nice?.length > 0) ||
    (props.softSkills.extra && props.softSkills.extra?.length > 0);

  const showMinLanguages = props.minLanguages && props.minLanguages.length > 0;

  return (
    <JobOfferSection name="skills" title={t('titles.skills')}>
      <StyledSkillsSection>
        <JobOfferLongText isMarkdown={props.migratedToMarkdown}>
          {props.intro}
        </JobOfferLongText>

        {showTechs && (
          <>
            <JobOfferSubsection title={t('skills.tech')}>
              {props.noStack && <SkillsNoStack />}

              {showTechsList && (
                <StyledSkillsLists>
                  {props.skills.must && props.skills.must.length > 0 && (
                    <SkillsList skillsListTitle={t('skills.mustHave')}>
                      {props.skills.must?.map((s, i) => (
                        <SkillsItem key={i} skillsItem={s} />
                      ))}
                    </SkillsList>
                  )}

                  {props.skills.nice && props.skills.nice.length > 0 && (
                    <SkillsList skillsListTitle={t('skills.niceToHave')}>
                      {props.skills.nice?.map((s, i) => (
                        <SkillsItem key={i} skillsItem={s} />
                      ))}
                    </SkillsList>
                  )}

                  {props.skills.extra && props.skills.extra.length > 0 && (
                    <SkillsList skillsListTitle={t('skills.extraPoints')}>
                      {props.skills.extra?.map((s, i) => (
                        <SkillsItem key={i} skillsItem={s} />
                      ))}
                    </SkillsList>
                  )}
                </StyledSkillsLists>
              )}
            </JobOfferSubsection>
          </>
        )}

        {showSoftSkills && (
          <JobOfferSubsection title={t('skills.skills')}>
            <StyledSkillsLists>
              {props.softSkills.must && props.softSkills.must.length > 0 && (
                <SkillsList skillsListTitle={t('skills.mustHave')}>
                  {props.softSkills.must?.map((s, i) => (
                    <SkillsSoftItem key={i} softSkills={s} />
                  ))}
                </SkillsList>
              )}

              {props.softSkills.nice && props.softSkills.nice.length > 0 && (
                <SkillsList skillsListTitle={t('skills.niceToHave')}>
                  {props.softSkills.nice?.map((s, i) => (
                    <SkillsSoftItem key={i} softSkills={s} />
                  ))}
                </SkillsList>
              )}

              {props.softSkills.extra && props.softSkills.extra.length > 0 && (
                <SkillsList skillsListTitle={t('skills.extraPoints')}>
                  {props.softSkills.extra?.map((s, i) => (
                    <SkillsSoftItem key={i} softSkills={s} />
                  ))}
                </SkillsList>
              )}
            </StyledSkillsLists>
          </JobOfferSubsection>
        )}

        {showMinLanguages && (
          <JobOfferSubsection title={t('skills.minLanguages')}>
            <StyledLanguages>
              {props.minLanguages?.map((l, i) => (
                <StyledLanguage key={i}>
                  <StyledLanguageName>{l.name}</StyledLanguageName>

                  {l.level !== 'not-defined' && (
                    <LevelLadder level={LANGUAGES_LEVELS.indexOf(l.level)} />
                  )}
                </StyledLanguage>
              ))}
            </StyledLanguages>
          </JobOfferSubsection>
        )}
      </StyledSkillsSection>
    </JobOfferSection>
  );
};

export default SkillsSection;
